import React, { useState } from "react";
import { useEffect } from "react";
import { DiliTextCP } from "../Utility/DiliTextCP";
import { NumberInput } from "../Utility/NumberInput";
import useDecodeToken from "../../hooks/useDecodeToken";

const InvoiceCard = ({
  index,
  invoiceNumber,
  handleChangeInvoiceNumber,
  handleInvoiceNumberKeyUp,
  handleFinishEnteringInvoiceNumber,
  isPurchasingInsurance,
  handleToggleIsPurchasingInsurance,
  declaredValue,
  handleChangeDeclaredValue,
  maximumValuationAmount,
  minimumValuationAmount,
  valuationRate,
  deleteInvoice,
  wasSubmitted,
  successfulSubmissionNotif,
  isCodOrCertified,
  COD,
  CertifiedFunds,
  currentInvoiceNumbers,
}) => {
  const [decodedToken] = useDecodeToken();
  // console.log(currentInvoiceNumbers)
  // console.log(currentInvoiceNumbers.includes(invoiceNumber));
  // console.log(
  //   new Set(currentInvoiceNumbers).size === currentInvoiceNumbers.length
  // );
  // const duplicateInvoice =
  //   new Set(currentInvoiceNumbers).size !== currentInvoiceNumbers.length;
  const duplicateInvoice =
    currentInvoiceNumbers.filter(
      (invoiceNumberFromList) => invoiceNumber === invoiceNumberFromList,
    ).length > 1;
  const containsComma = invoiceNumber.includes(",");

  const calculateValueCovered = () => {
    // console.log(declaredValue);
    return isPurchasingInsurance
      ? Math.min(
          maximumValuationAmount,
          declaredValue === "" ? 0 : declaredValue,
        ).toFixed(2)
      : Math.min(
          minimumValuationAmount,
          declaredValue === "" ? 0 : declaredValue,
        ).toFixed(2);
  };

  const getInsuranceFee = (isPreview = false) => {
    if (
      (isPreview || isPurchasingInsurance) &&
      declaredValue > minimumValuationAmount
    ) {
      return Math.max(
        2.5,
        Math.min(maximumValuationAmount, declaredValue) * valuationRate,
      ).toFixed(2);
    } else {
      return 0;
    }
  };

  useEffect(() => {
    setStartedTypingDeclaredValue(false);
  }, [successfulSubmissionNotif]);
  const [startedTypingDeclaredValue, setStartedTypingDeclaredValue] =
    useState(false);
  const onChangeDeclaredValue = (e) => {
    //This is to stop it from turning red when they enter non numbers.
    //If the field has the required attribute though this will block you from erasing all input as an empty input is not valid if it is required
    //should refactor EVERYTHING eventually
    // console.log(e.target.value);
    // if (
    //   // (!e.target.validity.valid || e.target.value <= 0) && //if you want to block them from starting with 0s/ only entering 0s
    //   !e.target.validity.valid &&
    //   e.target.value !== ""
    // ) {
    //   return;
    // }
    handleChangeDeclaredValue(e);
    setStartedTypingDeclaredValue(true);
  };

  const isDeclaredValueRequired = isPurchasingInsurance || isCodOrCertified;
  const isDeclaredValueValid =
    !isDeclaredValueRequired ||
    (!startedTypingDeclaredValue && !wasSubmitted) ||
    (isDeclaredValueRequired && declaredValue !== "" && declaredValue > 0);
  // console.log(wasSubmitted);
  // console.log(successfulSubmissionNotif);
  return (
    <div className="list-card-row">
      {index === 0 ? (
        <div className="card-list-close d-none d-md-flex"></div>
      ) : (
        <div
          className="card-list-close d-none d-md-flex"
          onClick={deleteInvoice}
        >
          ✕
        </div>
      )}

      <div className="list-card py-lg-0 py-4">
        <div className="list-card-inner-row row py-2 px-5">
          <div className="col-md-4">
            <div>
              <DiliTextCP
                inputClass="invoice-list-input"
                required
                type="text"
                label={"Invoice #" + (index + 1)}
                name={"invoice-" + (index + 1) + "-number"}
                value={invoiceNumber}
                onChange={handleChangeInvoiceNumber}
                onKeyUp={handleInvoiceNumberKeyUp}
                onBlur={handleFinishEnteringInvoiceNumber}
                wasSubmitted={wasSubmitted}
                validationTest={(input) => {
                  return (
                    !duplicateInvoice &&
                    invoiceNumber.length > 0 &&
                    !containsComma
                  );
                }}
                successfulSubmissionNotif={successfulSubmissionNotif}
                invalidText={
                  invoiceNumber.length < 1
                    ? index === 0
                      ? "Please enter an invoice number"
                      : "Please enter an invoice number or delete this row."
                    : duplicateInvoice
                      ? "Duplicate Invoice Detected"
                      : containsComma
                        ? "Commas are not allowed"
                        : "Unknown Error"
                }
                maxLength={13}
              />
              {/* <label>
                Invoice #{index + 1}
                <span className="required-star">*</span>
              </label>
              <input
                type="text"
                value={invoiceNumber}
                onChange={handleChangeInvoiceNumber}
                className="form-control invoice-list-input"
              /> */}
            </div>
            <div className="form-check">
              <input
                type="checkbox"
                className="form-check-input"
                disabled={
                  declaredValue <= minimumValuationAmount ||
                  decodedToken?.ClientId === 22927
                }
                checked={isPurchasingInsurance}
                onChange={handleToggleIsPurchasingInsurance}
              />
              <label
                htmlFor=""
                className="form-check-label add-insurance-label"
              >
                Add Insurance
              </label>
            </div>
          </div>
          {/* {isPurchasingInsurance && ( */}
          {/* <> */}
          <div className="col-md-4">
            <div>
              <label className={isDeclaredValueValid ? "" : "text-danger"}>
                Declared Value
                {isDeclaredValueRequired && (
                  <span className="required-star">*</span>
                )}
              </label>

              <div className="input-group">
                {/* <input
                  required={isDeclaredValueRequired}
                  type="tel"
                  pattern="^[0-9]\d*\.?\d{0,2}$"
                  value={declaredValue}
                  onChange={onChangeDeclaredValue}
                  className={
                    "form-control invoice-list-input " +
                    (isDeclaredValueValid
                      ? ""
                      : "border-danger bs-original-border-color-right")
                  }
                /> */}
                <NumberInput
                  className={
                    "form-control invoice-list-input " +
                    (isDeclaredValueValid
                      ? ""
                      : "border-danger bs-original-border-color-right")
                  }
                  required={isDeclaredValueRequired}
                  value={declaredValue}
                  onChange={onChangeDeclaredValue}
                  positiveOnly
                  blockScientificNotation
                  decimalPrecision={2}
                  min={isDeclaredValueRequired ? "0.01" : "0"}
                  max="999999999"
                  step=".01" // for decimals or else it says invalid on submission
                />
                <div className="input-group-append">
                  <div
                    className={
                      "input-group-text " +
                      (isDeclaredValueValid ? "" : "border-danger")
                    }
                    style={{ paddingTop: 0, paddingBottom: 0 }}
                  >
                    USD
                  </div>
                </div>
              </div>
              {!isDeclaredValueValid && isCodOrCertified ? (
                <small className={"form-text pl-1 text-danger"}>
                  {COD ? "Please enter a value for COD orders" : ""}
                  {CertifiedFunds
                    ? "Please enter a value for Certified Funds orders"
                    : ""}
                </small>
              ) : (
                !isDeclaredValueValid &&
                isPurchasingInsurance && (
                  <small className={"form-text pl-1 text-danger"}>
                    Please enter an amount if you wish to purchase insurance.
                  </small>
                )
              )}
            </div>
          </div>
          <div className="col-md-4">
            <div>
              <label>Insurance Fee</label>
              <input
                type="text"
                readOnly
                disabled
                value={"$" + getInsuranceFee()}
                className="form-control invoice-list-input"
              />
              {decodedToken?.ClientId !== 22927 && (
                <span className="amount-covered-display">
                  Amount covered: ${calculateValueCovered()}
                </span>
              )}
            </div>
            {/* <div className="row valuation-row">
              <div className="col-4 p-0">
                <div className="form-group" style={{ textAlign: "right" }}>
                  <label
                    className="valuation-header px-1"
                    style={{ marginLeft: "auto" }}
                  >
                    Valuation Rate
                  </label>
                  <input
                    style={{
                      marginLeft: "auto",
                      textAlign: "right",
                    }}
                    type="text"
                    readOnly
                    disabled
                    value={valuationRate * 100 + "%"} //*** Get valuation rate from BACKEND
                    className="form-control valuation-input valuation-rate-display"
                  />
                </div>
              </div>
              <div className="col-4 p-0">
                <label className="valuation-header px-1">Value Covered</label>
                <input
                  type="text"
                  readOnly
                  disabled
                  value={"$" + calculateValueCovered()}
                  className="form-control valuation-input valuation-value-covered-display"
                />
              </div>
              <div className="col-4 p-0">
                <label className="valuation-header px-1">Insurance Fee</label>
                <input
                  type="text"
                  readOnly
                  disabled
                  value={"$" + getInsuranceFee()}
                  className="form-control valuation-input insurance-fee-display"
                />
              </div>
            </div> */}
          </div>
          {declaredValue >= 1000 &&
            !isPurchasingInsurance &&
            decodedToken?.ClientId !== 22927 && (
              <div className="text-danger font-small ml-3">
                This is a high value item, are you sure you do not want to
                insure it for ${getInsuranceFee(true)}?
              </div>
            )}
          {/* </> */}
          {/* )} */}
        </div>
        {index === 0 ? null : (
          <div className="row justify-content-center d-md-none">
            <button
              type="button"
              className="btn btn-danger"
              onClick={deleteInvoice}
            >
              Delete Invoice
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default InvoiceCard;
